import React from "react";
import { OUTBOUND_URL } from "../data/characters";

const steps = [
  {
    n: "01",
    title: "Pick Your AI Character",
    body: "Browse cozy companions, anime characters, fantasy partners, dramatic personalities, romantic AI girls and original characters. Every AI character has a unique voice, backstory and chat style.",
  },
  {
    n: "02",
    title: "Open the Chat",
    body: "Choose a character and start messaging instantly. Your AI character chat begins the moment you say hi.",
  },
  {
    n: "03",
    title: "Build Your Story",
    body: "Roleplay, flirt, debate, confess, investigate, travel, fight, joke or create a completely original plot. The AI character remembers context and adapts to the way you write.",
  },
  {
    n: "04",
    title: "Come Back Anytime",
    body: "Save your favorites and continue exactly where you left off. Your character AI chat keeps the conversation alive across sessions.",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-[#0A0A0A] text-white py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12">
        <div className="max-w-3xl">
          <span className="text-xs sm:text-sm font-bold tracking-[0.25em] uppercase font-body text-[#00E5FF]">
            How It Works
          </span>
          <h2
            data-testid="how-it-works-title"
            className="font-display mt-4 text-4xl sm:text-6xl font-black tracking-tighter uppercase leading-[0.95]"
          >
            Start Your Character <br /> AI Chat in
            <span className="text-[#FFD60A]"> 4 Steps</span>
          </h2>
        </div>

        <ol className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s) => (
            <li
              key={s.n}
              data-testid={`step-${s.n}`}
              className="relative border-t-2 border-white/30 pt-6"
            >
              <div className="font-display text-7xl sm:text-8xl font-black text-white/15 leading-none">
                {s.n}
              </div>
              <h3 className="font-display mt-4 text-2xl font-black uppercase tracking-tight">
                {s.title}
              </h3>
              <p className="font-body mt-3 text-white/70 leading-relaxed">
                {s.body}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-16 flex justify-start">
          <a
            data-testid="how-it-works-cta"
            href={OUTBOUND_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="brutal-shadow-light inline-flex items-center gap-3 bg-[#00E5FF] text-black font-display font-black uppercase tracking-tight text-base sm:text-lg px-7 py-4 border-2 border-white"
          >
            Start Chatting Now →
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
